import { FileLink } from '@components/fileLink';
import { InfoLink } from '@components/infoLink';
import { useFragment } from 'react-relay';
import { documentsFragment } from './Documents.relay';
import type { DocumentsProps } from './types';

export const Documents: React.FC<DocumentsProps> = ({ component }) => {
  const data = useFragment(documentsFragment, component);

  return (
    <div className="documents-wrapper mt-2.5 flex flex-wrap items-start justify-between [&_.InfoLink-header]:max-[600px]:mt-4">
      <div className="documents-left inline-block w-[45%] align-top max-[1100px]:w-full">
        {data.files?.brochure ? <FileLink key="document-brochure" expanded={true} fileLink={data.files.brochure} /> : null}
        {data.files?.factsheet ? <FileLink key="document-factsheet" expanded={true} fileLink={data.files.factsheet} /> : null}
        {data.files?.kid ? <FileLink key="document-kid" expanded={true} fileLink={data.files.kid} /> : null}
      </div>
      <div className="documents-right ml-[5%] inline-block w-[45%] align-top max-[1100px]:mt-0 max-[1100px]:ml-0 max-[1100px]:w-full max-[600px]:mt-4">
        {/* biome-ignore lint/suspicious/noArrayIndexKey: fileLink is a fragment ref, no stable identifier available */}
        {data.files?.others?.map((fileLink, idx) => (fileLink ? <FileLink key={`other-${idx}`} expanded={false} fileLink={fileLink} /> : null))}
      </div>
      {/* <div className="infolinks inline-block w-full"> */}
      <div className="grid grid-cols-1 desktop:grid-cols-2 gap-20 mt-5">
        {data.infolinks?.map((infoLink, idx) => {
          if (!infoLink) {
            return null;
          }
          const isRouterLink = infoLink.url.indexOf('infoservice') === -1;
          return <InfoLink key={infoLink.url} infoLink={infoLink} isRouterLink={isRouterLink} openInSameTab={true} />;
        })}
      </div>
    </div>
  );
};
